export const AUDIT_STATUSES = {
  UNKNOWN: {
    name: 'UNKNOWN',
    title: 'Unknown',
    icon: 'common.unknown',
  },
  RUNNING: {
    name: 'RUNNING',
    title: 'Running',
    icon: 'common.loading',
  },
  COMPLETED: {
    name: 'COMPLETED',
    title: 'Completed',
    icon: 'configdrift.audit_policy_passed',
  },
  ERROR: {
    name: 'ERROR',
    title: 'Error',
    icon: 'common.error',
  },
  CANCELED: {
    name: 'CANCELED',
    title: 'Canceled',
    icon: 'common.skipped',
  },
  // Obsolete options left for backward compatibility
  SUCCESSFUL: {
    name: 'SUCCESSFUL',
    title: 'Passed',
    icon: 'configdrift.audit_policy_passed',
  },
  FAILED: {
    name: 'FAILED',
    title: 'Failed',
    icon: 'configdrift.audit_policy_failed',
  },
};

export const PERMISSION_LEVEL = {
  auditManageLevel1: {
    name: 'auditManageLevel1',
    title: '1',
  },
  auditManageLevel2: {
    name: 'auditManageLevel2',
    title: '2',
  },
  auditManageLevel3: {
    name: 'auditManageLevel3',
    title: '3',
  },
};
